export default "__VITE_ASSET__CAeTjWEH__"